import { useState } from 'react';
import { LinkSpec } from '../../../SearchFooter/preset-links/helpers';
import {
  LinkContainer,
  LinkSectionView,
  LinkTitle,
  StyledLink,
  SeeMoreToggle,
  StyledExpandMore,
  StyledExpandLess,
} from './SidebarLinkSection.styles';

interface Props {
  title: string;
  links: LinkSpec[];
}

const MAX_ITEMS = 10;

export const SidebarLinkSection = ({ title, links }: Props) => {
  const [itemLinks] = useState(links);
  const [showingMore, setShowingMore] = useState(false);

  const numberOfItems = showingMore ? itemLinks.length : MAX_ITEMS;

  if (links.length === 0) return null;

  return (
    <LinkSectionView>
      <LinkTitle>{title}</LinkTitle>

      <LinkContainer>
        {itemLinks.slice(0, numberOfItems).map(link => (
          <StyledLink key={`${link.title}-${String(link.url)}`} to={link.url}>
            {link.title}
          </StyledLink>
        ))}

        {itemLinks.length > MAX_ITEMS && (
          <SeeMoreToggle
            onClick={() => {
              setShowingMore(!showingMore);
            }}
            rightContent={
              showingMore ? (
                <StyledExpandLess fontSize="small" />
              ) : (
                <StyledExpandMore fontSize="small" />
              )
            }
          >
            Show {showingMore ? 'less' : 'more'}
          </SeeMoreToggle>
        )}
      </LinkContainer>
    </LinkSectionView>
  );
};
